const tag = document.createElement('script');
tag.src = 'https://www.youtube.com/iframe_api';
const firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

function getYouTubeID(watchUrl) {
    try {
        let videoId = '';

        // Handle standard watch URLs and short URLs
        if (watchUrl.includes('youtu.be/')) {
            videoId = watchUrl.split('youtu.be/')[1].split(/[?#]/)[0];
        } else {
            const urlObj = new URL(watchUrl);
            videoId = urlObj.searchParams.get('v');
        }

        if (videoId && videoId.length === 11) {
            return videoId;
        }

        throw new Error('Invalid YouTube video ID extracted');
    } catch (error) {
        console.error('Conversion failed:', error.message);
        return null;
    }
}
function onPlayerReady(event) {
    event.target.playVideo();
}

const triggers = document.querySelectorAll('.film-trigger');
const modal = document.getElementById('film-modal');
const modalBody = modal.querySelector('.modal-body');
triggers.forEach(el => {
    el.addEventListener('click', function (e) {
        e.preventDefault();
        const videoId = getYouTubeID(this.dataset.url);
        if (!videoId) {
            return;
        }
        const player = new YT.Player('film-player', {
            width: '560',
            height: '315',
            videoId: videoId,
            playerVars: {
                'playsinline': 1,
                'autoplay': 1,
                'rel': 0,
            },
            events: {
                'onReady': onPlayerReady
            }
        });

        modal.showPopover();

        modal.addEventListener('toggle', e => {
            if (e.newState === 'closed') {
                player.stopVideo();
                modalBody.innerHTML = '<div id="film-player"></div>';
            }
        });
    });
});
